import type {
  SliderSchemaType,
  SliderFontSchemaType,
  ElementSchemaType,
} from '@vedalib/editor/lib/brand'
import type { EditorElement, SliderElementValue } from '@vedalib/editor/lib/elements'

import type {
  FCDemoType,
  FCElementType,
  FCFormValueType,
  BrandFormsMapType,
  FCFormBrandType,
} from '../../elements.types'

export type SliderDemoType = FCDemoType<SliderSchemaType, SliderFontSchemaType>

export type SliderEditorElement = EditorElement<
  SliderElementValue,
  SliderSchemaType,
  SliderFontSchemaType
>

export type SliderElementType = FCElementType<
  SliderElementValue,
  SliderSchemaType,
  SliderFontSchemaType,
  ElementSchemaType,
  SliderStateType
>

export type SliderFormValueType = FCFormValueType<
  SliderElementValue,
  SliderSchemaType,
  SliderFontSchemaType,
  ElementSchemaType,
  SliderStateType
>

export type SliderFormBrandType = FCFormBrandType<
  SliderElementValue,
  SliderSchemaType,
  SliderFontSchemaType,
  ElementSchemaType,
  SliderStateType
>

export type SliderBrandForms = BrandFormsMapType<
  SliderElementValue,
  SliderSchemaType,
  SliderFontSchemaType,
  ElementSchemaType,
  SliderStateType
>

export type SliderStateType = {
  active: string | null
}

export enum ArrowPosition {
  slide = 'slide',
  progress = 'progress',
}
